import React, {
	Component
} from 'react';

import styled from 'styled-components';
import {history} from '../history';
import { observer } from 'mobx-react';
import { store } from '../stores/mainStore';
import { padStart } from 'lodash';
import { comm } from '../comm';
import { withRouter } from "react-router";
import { Sprite } from './Sprite';
import { integration } from '../integration';
import { Sparkles } from './Sparkles';

const Body = styled.div`
	display: flex;
	width: 100%;
	flex-shrink: 0;
	flex-grow: 0;
	flex-direction: row;
	align-items: center;
	font-size: 3vw;
	overflow: visible;
	justify-content: space-between;
	align-items: flex-end;
	height: 16.5vw;
	z-index: 10;
	position: relative;
`

const NavItem = styled.div`
	position: relative;
	height: 100%;
	box-sizing: border-box;
	line-height: 1em;
	font-size: 3.5vw;
	flex: 1 1 20vw;
	text-align: center;
	color: white;
	font-weight: 500;
	text-shadow: 0.3vw 0.3vw 0.3vw #830178, -0.3vw -0.3vw 0.3vw #830178, 0.3vw -0.3vw 0.3vw #830178, -0.3vw 0.3vw 0.3vw #830178;
	letter-spacing: -0.3vw;
	/* -webkit-text-stroke: 2px #830178; */
	/* height: 23vw; */
	display: flex;
	align-items: flex-end;
	& > img {
		width: 25vw;
	}
`

const HeartTimer = styled.div`
	width: 100%;
	position: absolute;
	top: 5.3vw;
	text-align: center;
	font-family: "Open Sans", "Jost", sans-serif;
	font-size: 2.7vw;
	text-shadow: none;
	letter-spacing: normal;
	font-weight: 700;
`
const HeartCollect = styled.img`
	position: absolute;
	top: 4vw;
	left: 5vw;
	width: 15vw !important;
`

const HeartCount = styled.div`
	position: absolute;
	top: 0.5vw;
	left: 5vw;
	width: 15vw !important;
	text-align: center;
	font-family: "Open Sans", "Jost", sans-serif;
	font-size: 4vw;
	/* text-shadow: none; */
`

const Bang = styled.img`
	width: 10vw !important;
	position: absolute;
	top: -10vw;
	right: 1vw;
`

@observer
class BottomBar extends Component {

	constructor(props){
		super(props);
		this.state = {
			claimTime: this.calculateClaimTime()
		}
		this.interval = setInterval(this.updateClaimTime ,1000);
	}

	componentWillUnmount(){
		clearInterval(this.interval);
	}

	updateClaimTime = () => {
		this.setState({
			claimTime: this.calculateClaimTime()
		});
	}

	calculateClaimTime = () => {
		var time = store.user.localClaimTime - Date.now();
		var second = 1000;
		var minute = second * 60;
		var hour = minute * 60;
		if(time <= 0){
			return true;
		}
		if(store.user.localClaimTime){
			let r = [0,0,0];
			[hour,minute,second].forEach((t,i) => {
				while(time >= t){
					r[i]++;
					time -= t;
				}
			})
			return r;
		} else {
			return [-1,-1,-1];
		}
	}

	homeButton = (currentRoute) => {
		if(!currentRoute && store.lastButtonTime + 1000 < Date.now()){
			window.manager.playAudio("transitionsMovement");
			integration.postAnalyticsEvent(`press_home_icon`, `navigation`);
			history.push(`/`);
			console.log("PRESSED HOME BUTTON");
			store.lastButtonTime = Date.now();
		}
	}

	showAchievements = (currentRoute) => {
		if(!currentRoute && store.lastButtonTime + 1000 < Date.now()){
			window.manager.playAudio("transitionsMovement");
			integration.postAnalyticsEvent(`press_achievements_icon`, `navigation`);
			history.push('/achievements');
			store.lastButtonTime = Date.now();
		}
	}

	goToNewGame = (currentRoute) => {
		if(!currentRoute && store.lastButtonTime + 1000 < Date.now()){
			window.manager.playAudio("transitionsMovement");
			integration.postAnalyticsEvent(`new_game_button_footer`, `navigation`, 'footer');
			history.push('/game-type-select');
			store.lastButtonTime = Date.now();
		}
	}

	claimHearts = () => {
		window.manager.playAudio("transitionsMovement");
		integration.postAnalyticsEvent(`menu_press_timer`,'navigation');
		if(store.user.canClaimTimedReward){
			const heartAmount = store.user.level > 10 ? 2 : 1;
			store.showTimedHeartAward = heartAmount;
			comm.ClaimTimedHearts()
			.then(({Payload}) => {
				window.manager.playAudio("HeartstoHud_multiple");
				integration.postAnalyticsEvent(`reward_timer_collect_hearts`, `economy`, store.showTimedHeartAward);
				store.user.localClaimTime = Date.now() - (Payload.ServerTime - Payload.NextClaimTime) * 1000
				var start = Date.now();
				store.user.updateHearts()
				.then(() => {
					var diff = Date.now() - start;
					setTimeout(store.user.heartAnimComplete, 1500 - diff + (0.1 * heartAmount));
				})
			});
		} else {
			store.showCountdownModal = true;
		}
	}
	render(){
		const { location } = this.props;
		// console.log('path:',location.pathname);
		var route = 'home';
		switch (location.pathname) {
			case '/achievements':
				route = 'achievements';
				break;
			case '/game-type-select':
				route = 'newgame';
				break;
			default:
				break;
		}
		return (
			<Body>
				<NavItem>
					<Sprite onClick={()=> this.goToNewGame(route === 'newgame')} w={25} path="/assets/languages/" localize sprite={`navbar_newgame_${route === 'newgame' ? 'on' : 'off'}_hires.png`}/>
				</NavItem>
				<NavItem className={route === 'achievements' && 'active'}>
					<Sprite onClick={() => this.showAchievements(route === 'achievements')} w={25} path="/assets/languages/" localize sprite={`navbar_ach_${route === 'achievements' ? 'on' : 'off'}_hires.png`}/>
					{Object.keys(store.rewardsByAch).length > 0 && <Bang src="/assets/btn_nav_new_ach.png"/>}
				</NavItem>
				<NavItem>
					<Sprite onClick={() => this.homeButton(route === 'home')} w={25} path="/assets/languages/" localize sprite={`navbar_home_${route === 'home' ? 'on' : 'off'}_hires.png`}/>
				</NavItem>
				<NavItem onClick={this.claimHearts}>
					<Sprite w={25} path="/assets/languages/" localize sprite="navbar_hearts_off_hires.png"/>
					<HeartCount>+{store.user.level > 10 ? 2 : 1}</HeartCount>
					{this.state.claimTime === true ? (
						<HeartCollect src={`/assets/languages/${store.settings.language}/btn_collect_hearts.png`}/>
						) : (
							<HeartTimer>{padStart(this.state.claimTime[0].toString(),2,0)}:{padStart(this.state.claimTime[1].toString(),2,0)}:{padStart(this.state.claimTime[2].toString(),2,0)}</HeartTimer>
							)}
				</NavItem>
				{Object.keys(store.rewardsByAch).length > 0 && (
					<Sparkles
						amount={15}
						style={{
							top: '-9vw',
							left: '25vw',
							height: '12vw',
							width: '16vw'
						}}
					/>
				)}
				{this.state.claimTime === true && (
					<Sparkles
						amount={15}
						style={{
							top: '-9vw',
							left: '75vw',
							height: '12vw',
							width: '16vw'
						}}
					/>
				)}
			</Body>
		);
	}
}

const BottomBarWithRouter = withRouter(BottomBar);
export {BottomBarWithRouter as BottomBar};
